import React from 'react';

export default function Reboot(props) {
  const { state, detect } = props.store;
  const detectCom = Object.values(detect).map(item => (
    <p key={item.name}>{item.name}：{item.value}</p>
  ));
  return (
    <div>
      <h4 className="popup-title">实时检测数据</h4>
      <div className="">
        <p>车位状态：{state}</p>
        <p><b>地磁检测状态：</b></p>
        {detectCom}
      </div>
    </div>
  );
}
